/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S5_No_Tracking_StrongInputs */

const tr_cerez_s5_no_tracking_strong = /** @type {(inputs: Cerez_S5_No_Tracking_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kullanılmamaktadır`)
};

const en_cerez_s5_no_tracking_strong = /** @type {(inputs: Cerez_S5_No_Tracking_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`are not used`)
};

const de_cerez_s5_no_tracking_strong = /** @type {(inputs: Cerez_S5_No_Tracking_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`werden nicht verwendet`)
};

const ru_cerez_s5_no_tracking_strong = /** @type {(inputs: Cerez_S5_No_Tracking_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`не используются`)
};

/**
* | output |
* | --- |
* | "are not used" |
*
* @param {Cerez_S5_No_Tracking_StrongInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s5_no_tracking_strong = /** @type {((inputs?: Cerez_S5_No_Tracking_StrongInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S5_No_Tracking_StrongInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s5_no_tracking_strong(inputs)
	if (locale === "de") return de_cerez_s5_no_tracking_strong(inputs)
	if (locale === "ru") return ru_cerez_s5_no_tracking_strong(inputs)
	return tr_cerez_s5_no_tracking_strong(inputs)
});